/**
 * EventLearningService
 * Events hub Stage 1B learning: rule proposals learned from the links people approved, and the
 * learning settings. Accepting a proposal creates a rule with AutoApply off.
 * Route: events/api/events/learning (Admin role OR Event.Learning.Review)
 */
import { BaseService } from '../base/BaseService';
import { unwrapEventsResponse as unwrap } from './unwrapEventsResponse';
export class EventLearningService extends BaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? EventLearningService.DEFAULT_SERVICE_PATH,
            basePath: EventLearningService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /** GET api/events/learning/candidates?statusId (see EventRuleCandidateStatusIds). */
    async candidates(statusId) {
        const res = await this.candidatesRaw(statusId);
        return res.data ?? [];
    }
    candidatesRaw(statusId) {
        return this.http.get(this.buildUrlWithParams('candidates', { statusId }));
    }
    /** POST api/events/learning/candidates/{id}/accept. Creates a rule (origin LearnedRule, AutoApply off). */
    async accept(id, request = {}) {
        return unwrap(await this.acceptRaw(id, request), `Could not accept proposal ${id}`);
    }
    acceptRaw(id, request = {}) {
        return this.http.post(this.buildUrl(`candidates/${id}/accept`), {
            targetKeys: request.targetKeys ?? [],
            name: request.name ?? null,
        });
    }
    /** POST api/events/learning/candidates/{id}/reject. */
    async reject(id) {
        return unwrap(await this.rejectRaw(id), `Could not reject proposal ${id}`);
    }
    rejectRaw(id) {
        return this.http.post(this.buildUrl(`candidates/${id}/reject`));
    }
    /** POST api/events/learning/candidates/{id}/snooze. */
    async snooze(id) {
        return unwrap(await this.snoozeRaw(id), `Could not snooze proposal ${id}`);
    }
    snoozeRaw(id) {
        return this.http.post(this.buildUrl(`candidates/${id}/snooze`));
    }
    /** GET api/events/learning/settings. */
    async getSettings() {
        return unwrap(await this.getSettingsRaw(), 'Learning settings not found');
    }
    getSettingsRaw() {
        return this.http.get(this.buildUrl('settings'));
    }
    /** PUT api/events/learning/settings. */
    async updateSettings(settings) {
        return unwrap(await this.updateSettingsRaw(settings), 'Could not save the learning settings');
    }
    updateSettingsRaw(settings) {
        return this.http.put(this.buildUrl('settings'), settings);
    }
}
EventLearningService.DEFAULT_SERVICE_PATH = 'events';
EventLearningService.BASE_PATH = 'api/events/learning';
//# sourceMappingURL=EventLearningService.js.map